module.exports = __webpack_public_path__ + "files/652c79d384f307b9376d4fe0556e9320.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-4.png
// module id = 1475
// module chunks = 60